import React, { useEffect, useState } from "react";
import { CMSPageDetails } from "../services/website.services";

const sections = [
    { title: "1. Information We Collect", content: "We collect information you provide directly and data generated when you use the platform including account details, wardrobe content, and usage data." },
    { title: "2. How We Use Your Information", content: "Your information is used to deliver, improve, and secure your Online Closet experience including outfit suggestions and payment processing." },
    { title: "3. Data Sharing and Disclosure", content: "We do not sell your personal data. We may share data only when necessary to operate the service or comply with legal requirements." },
    { title: "4. Cookies and Tracking", content: "We use cookies to remember preferences, analyze traffic, and improve user experience. You can manage cookie settings through your browser." },
    { title: "5. Data Security", content: "We implement reasonable technical and organizational safeguards to protect your information against unauthorized access." },
    { title: "6. Data Retention", content: "We retain personal information only as long as necessary to provide services and comply with legal obligations." },
    { title: "7. Your Privacy Rights", content: "You may have rights to access, correct, delete, or restrict processing of your personal data depending on your region." },
    { title: "8. Contact Us", content: "For privacy-related questions, contact us via the website contact page or the official support email." },
]

export default function WebsitePrivacyPage() {
    const [data, setData] = useState(null);

    useEffect(() => {
        CMSPageDetails("privacy_policy_web", "website").then((res) => {
            if (res.data) {
                setData(res.data);
            }
        });
        window.scrollTo(0, 0);
    }, []);

    return (
        <section className="swayyd-section" style={{ paddingTop: "120px" }}>
            <div className="legal-wrapper">
                <div className="legal-header">
                    <span className="section-eyebrow">Legal</span>
                    <h1 className="section-title">
                        {data?.title ? data.title : <>Privacy <em>Policy</em></>}
                    </h1>
                    <p className="section-sub">
                        {data?.short_description || "This Privacy Policy explains how we collect, use, and protect your personal information."}
                    </p>
                    <p style={{ fontSize: "13px", color: "var(--faint)", fontWeight: 500 }}>
                        Last updated: {data?.updatedAt ? new Date(data.updatedAt).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }) : "March 26, 2026"}
                    </p>
                </div>

                <div className="legal-card">
                    {data?.description ? (
                        <div className="legal-content" dangerouslySetInnerHTML={{ __html: data.description }} />
                    ) : (
                        <div className="legal-content">
                            {sections.map((s, i) => (
                                <div key={i} style={{ marginBottom: "24px" }}>
                                    <h2>{s.title}</h2>
                                    <p>{s.content}</p>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}